import { createFilterOptions } from '@mui/material'

import { Organization } from '../../../../generated/graphql'

import { AuctionOrganization } from './UserAccountSelect.types'

export const getOptionLabel = ({ displayName, orgId }: Organization): string => {
    if (displayName && orgId) {
        return `${displayName} (${orgId})`
    }

    return displayName || orgId || ''
}

export const filterAuctions = createFilterOptions<AuctionOrganization>({
    stringify: ({ displayName, orgId }) => `${displayName || ''} ${orgId}`,
})
